export default __webpack_public_path__ + "static/media/cookie.c587352c.svg";